import * as React from 'react';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
// import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { toast, Slide } from 'react-toastify';
import configAxios from '../service/configAxios';
import Box from '@mui/material/Box';


export default function CompanyContact() {
  const [emailPartners, setEmailPartners] = React.useState('');
  const [emailCompany, setEmailCompany] = React.useState('');


  function submitPartiners(event) {
    event.preventDefault();
    if (!emailPartners) {
      toast.warn('Por favor, preencha o seu email', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: 'light',
        transition: Slide
      });
      return;
    }

    const lead = {
      name: 'Site Phorm Pass Empresas',
      email: emailPartners,
      subject: 'Solicitação de cadastro de empresas na phorm Pass',
      message: 'Entrar em contato com o email',
    };

    configAxios
      .post('/leads/sendEmail', lead)
      .then(() => {
        toast.success('Você solicitou com sucesso o nosso contato!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: 'light',
          transition: Slide
        });
        setEmailPartners();
      })
      .catch((error) => {
        console.log(error)
        toast.warn('Não foi possível solicitar o contato, por favor tente novamente!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: 'light',
          transition: Slide
        });
      });
  }

  function handleInputChangePartners(event) {
    setEmailPartners(event.target.value);
  }

  function handleSubmitCompany(event) {
    event.preventDefault();
    if (!emailCompany) {
      toast.warn('Por favor, preencha o seu email', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: 'light',
        transition: Slide
      });
      return;
    }
    const lead = {
      name: 'Site Phorm Parceiro',
      email: emailCompany,
      subject: 'Solicitação de credenciamento Parceiro phorm',
      message: 'Entrar em contato com o email',
    };


    configAxios
      .post(`/leads/sendEmail`, lead)
      .then(() => {
        toast.success('Você solicitou com sucesso o nosso contato!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: 'light',
          transition: Slide
        });
        setEmailCompany();
      })
      .catch(() => {
        toast.warn('Não foi possível solicitar o contato, por favor tente novamente!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: 'light',
          transition: Slide
        });
      });
  }

  function handleInputChangeCompany(event) {
    setEmailCompany(event.target.value);
  }


  const styled = {

    b2b: {
      padding: '100px 0',
      background: 'radial - gradient(circle at center, rgba(194, 233, 18, 0.05) 0 %, rgba(10, 11, 14, 1) 100 %) ',
    },

    container: {
      width: '100%',
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 24px',
    },

    splitGrid: {
      display: 'grid',
      gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
      gap: '32px',
    },

    splitCard: {
      background: '#151820',
      border: '1px solid #ffffff55',
      borderRadius: '24px',
      padding: { xs: '24px', sm: '48px' }, // Menos padding no mobile
      display: 'flex',
      flexDirection: 'column',
      minHeight: '450px', // Ajuda a manter os cards do mesmo tamanho
    },

    textGradient: {
      background: 'linear-gradient(135deg, #ffffff, #A5E13B)', // Substituí var(--primary) pela sua cor verde
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      fontWeight: 'inherit', // Para manter o peso do h2,
      lineHeight: 1.2,
      fontWeight: 700,
      fontSize: '3rem',
      marginBottom: '24px',
      letterSpacing: '-1px', // O valor negativo deve ser uma string '-1px'
      lineHeight: 1.2,
    },

    splitCardText: {
      color: '#9FA4B4',
      marginBottom: '24px',
      lineHeight: '1.7',
      position: 'relative',
    },

    uiStyle: {
      listStyle: 'none'
    },

    liStyle: {
      position: 'relative',
      paddingLeft: '32px',
      marginBottom: '16px',
      color: '#fff',
      fontSize: '1rem',
      listStyle: 'none',
      display: 'flex',
      alignItems: 'center',
      // O seletor abaixo só funciona via propriedade SX do MUI
      '&::before': {
        content: '"✔"',
        position: 'absolute',
        left: 0,
        color: '#A5E13B',
        fontWeight: 'bold',
        fontSize: '1.2rem',
      }
    },

    QuickForm: {
      display: 'flex',
      // Mudança: No mobile vira coluna, no desktop vira linha
      flexDirection: { xs: 'column', sm: 'row' },
      gap: '12px',
      marginTop: 'auto',
      width: '100%', // Garante que o form ocupe a largura total
    },

    btn: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '14px 24px', // Reduzi a altura (estava 25px) para alinhar com o input
      borderRadius: '50px',
      fontWeight: '600',
      fontSize: '0.85rem',
      cursor: 'pointer',
      border: 'none',
      whiteSpace: 'nowrap',
      backgroundColor: '#A5E13B',
      color: '#000',
      boxShadow: '0 4px 20px rgba(165, 225, 59, 0.3)',
      // No mobile, o botão ocupa a largura toda
      width: { xs: '100%', sm: 'auto' },

      // EFEITO HOVER (O Brilho do Figma)
      '&:hover': {
        backgroundColor: '#b8f54a', // Um verde levemente mais claro
        transform: 'translateY(-2px)', // Sobe um pouquinho
        boxShadow: '0 8px 25px rgba(165, 225, 59, 0.5)', // Brilho intenso
      },
      '&:active': {
        transform: 'translateY(0)',
      }
    },

    quickFormInput: {
      flexGrow: '1',
      background: '#0D0E12', // Cor escura do input
      border: '1px solid #ffffff22',
      padding: '16px 24px',
      borderRadius: '50px',
      color: '#ffffff',
      outline: 'none',
      transition: '0.3s',
      '&:focus': {
        borderColor: '#A5E13B',
      }
    }
  }

  return (
    <Container id="CompanyContact" sx={styled.b2b} >
      <Box sx={styled.container}>
        <Box sx={styled.splitGrid}>

          <Box sx={styled.splitCard}>
            <Typography component="h3" variant="h3" sx={styled.textGradient}>
              Phorm para empresas
            </Typography>

            <Typography
              variant="p"
              sx={styled.splitCardText}
            >
              Funcionários saudáveis e felizes são mais produtivos. Leve o bem-estar integral para sua equipe através do nosso programa <em>Mind Fitness</em>.
            </Typography>

            <Box component="ul" sx={styled.uiStyle}>
              <Box component="li" sx={styled.liStyle}>Atraia e retenha talentos promovendo qualidade de vida.</Box>
              <Box component="li" sx={styled.liStyle}>Reduza custos com planos de saúde corporativos.</Box>
              <Box component="li" sx={styled.liStyle}>Obtenha relatórios de engajamento do seu time.</Box>
            </Box>

            <form
              style={styled.QuickForm}
              onSubmit={handleSubmitCompany}>
              <input
                style={styled.quickFormInput}
                id="outlined-basic"
                hiddenLabel
                variant="outlined"
                aria-label="Digite o seu melhor e-mail"
                placeholder="Digite o seu melhor e-mail"
                onChange={(event) => handleInputChangeCompany(event)}
                type="email"
                value={emailPartners || ''}
                required
                inputProps={{
                  autoComplete: 'off',
                  'aria-label': 'Digite o seu email'
                }}
              />
              <Button style={styled.btn} type="submit">
                Solicitar contato
              </Button>
            </form>
          </Box>

          <Box sx={styled.splitCard}>
            <Typography component="h3" variant="h3" sx={styled.textGradient}>
              Phorm para Parceiros
            </Typography>

            <Typography
              variant="p"
              sx={styled.splitCardText}
            >
              É dono de uma academia ou studio? Aumente sua receita conectando-se aos nossos usuários. Sua busca por novos alunos acaba aqui.
            </Typography>

            <Box component="ul" sx={styled.uiStyle}>
              <Box component="li" sx={styled.liStyle}>Remuneração atrativa por utilização do seu espaço.</Box>
              <Box component="li" sx={styled.liStyle}> Acesso a milhares de clientes corporativos.</Box>
              <Box component="li" sx={styled.liStyle}>Marketing digital impulsionado pela marca Phorm.</Box>
            </Box>

            <form
              style={styled.QuickForm}
              onSubmit={submitPartiners}>
              <input
                style={styled.quickFormInput}
                id="outlined-basic"
                hiddenLabel
                variant="outlined"
                aria-label="Digite o seu melhor e-mail"
                placeholder="Digite o seu melhor e-mail"
                onChange={(event) => handleInputChangePartners(event)}
                type="email"
                value={setEmailPartners || ''}
                required
                inputProps={{
                  autoComplete: 'off',
                  'aria-label': 'Digite o seu email'
                }}
              />
              <Button style={styled.btn} type="submit">
                Seja um Parceiro
              </Button>
            </form>
          </Box>

        </Box>
      </Box>
    </Container >
  );
}
